import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';

export const useStyles = makeStyles(
    (theme: Theme) =>
        createStyles({
            userRolesSection: {
                marginTop: theme.spacing(2),
                display: 'flex',
                flexDirection: 'column',
                padding: theme.spacing(0, 2, 0, 2),
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: '4px',
            },
            userRolesSummary: {
                display: 'flex',
                flexDirection: 'column',
            },
            userRolesContainer: {
                display: 'flex',
                flexFlow: 'row wrap',
                justifyContent: 'flex-start',
                columnGap: '1rem',
                rowGap: '1rem',
            },
            roleCount: {
                color: theme.palette.text.secondary,
                fontWeight: 400,
                fontSize: '1rem',
            },
            userRoleCheckbox: {
                flex: '1 1 175px',
                maxWidth: '20rem',
                minWidth: '175px',
                display: 'flex',
                alignItems: 'start',
                flexDirection: 'column',
                paddingInlineStart: '0.5rem',
                boxSizing: 'border-box',
            },
            userRoleAnnotation: {
                marginInlineStart: '1.3rem',
            },
            badge: {
                marginLeft: theme.spacing(-1),
            },
            wrapper: {
                display: 'flex',
                alignItems: 'center',
            },
        }),
    {
        name: 'UserIlluminateRoles-',
    },
);
